(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MacroActionsDeleteController', MacroActionsDeleteController);

    MacroActionsDeleteController.$inject = ['$uibModalInstance', 'entity', 'MacroActions', 'Macro'];

    function MacroActionsDeleteController($uibModalInstance, entity, MacroActions, Macro) {
        var vm = this;
        vm.command = null;

        // Handle both promise and direct entity
        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.command = entity;
            });
        } else {
            vm.command = entity;
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            // Check if it's a Greengrass command
            if (vm.command.isGreengrass) {
                console.log('Deleting Greengrass command:', id, 'from macro:', vm.command.macroId);

                Macro.deleteGreengrassCommand({
                    commandId: id,
                    macroId: vm.command.macroId
                }, function(response) {
                    console.log('Greengrass command deleted successfully');
                    $uibModalInstance.close(true);
                }, function(error) {
                    console.error('Error deleting Greengrass command:', error);
                    $uibModalInstance.dismiss('error');
                });
            } else {
                // Traditional macro action delete
                MacroActions.delete({id: id}, function () {
                    $uibModalInstance.close(true);
                });
            }
        };
    }
})();
